import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {DataProviderService} from "@app/data-provider.service";
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/map';
import {Observable} from "rxjs";
import {map, tap} from "rxjs/operators";
import {Chat} from "@app/modulo-agenda/chat/chat";

@Injectable()
export class ChatTareaService {
    private serviceUrl: string;
    constructor(
        public http: HttpClient,
        private dataProviderService: DataProviderService,
    ) { this.serviceUrl = this.dataProviderService.getServiceUrl() + 'agenda/chat/tarea'; }

    /** marcarLeido=false trae la conversación sin darla por leída (panel minimizado). */
    public getChat(idTarea, marcarLeido: boolean = true): Observable<Chat[]> {
        return this.http.get(this.serviceUrl + '/' + idTarea + '?marcarLeido=' + (marcarLeido ? '1' : '0'), this.dataProviderService.authHeader())
            .pipe(
                map(this.mapChat),
                tap(data => {
                    return data
                })
            );
    }

    /** Da por leída la conversación para el usuario actual (al abrir el panel). */
    public marcarLeido(idTarea: number): Promise<any> {
        if (!idTarea) {
            return Promise.reject();
        }
        return this.http.post(this.serviceUrl + '/' + idTarea + '/leido', '{}', this.dataProviderService.authHeader())
            .toPromise();
    }

    public getChatCount(idTarea: number): Promise<number> {
        if (!idTarea) {
            return Promise.reject();
        }
        return this.http.get(this.serviceUrl + '/' + idTarea + '/count', this.dataProviderService.authHeader())
            .toPromise()
            .then((res: any) => {
                return res.count;
            });
    }

    public checkUnreadMsgs(idTarea: number): Promise<{ idTarea: number, hasNewMessage: boolean, count: number }> {
        if (!idTarea) {
            return Promise.reject();
        }
        return this.http.get(this.serviceUrl + '/getUnreadMsgs/' + idTarea, this.dataProviderService.authHeader())
            .toPromise()
            .then((res: any) => {
                return res;
            });
    }

    private mapChat(chat): Array<Chat> {
        return chat
    }

    public getUnreadChats(): Observable<{ tarea_id: number, usuario_id: number, ultimo_acceso: string, fecha: string, nro_mensajes : number, titulo: string }[]> {
        return this.http.get<{ tarea_id: number, usuario_id: number, ultimo_acceso: string, fecha: string, nro_mensajes: number, titulo: string }[]>(this.serviceUrl + '/unread/unread', this.dataProviderService.authHeader())
            .pipe(
                map((res: any) => res)
            );
    }

    public send(idTarea: number, message: string): Promise<Chat> {
        let elementoDTO = this.conformarDTO(idTarea, message);
        return this.http.post(this.serviceUrl, JSON.stringify(elementoDTO), this.dataProviderService.authHeader())
            .toPromise()
            .then((res: Chat) => {
                return res;
            })
            .catch(this.handleError);
    }

    public conformarDTO(idTarea: number, message: string) {
        return {
            message: message,
            idTarea: idTarea
        };
    }

    private handleError(error: any): Promise<any> {
        // console.error('An error occurred', error.error); // for demo purposes only
        return Promise.reject(error.error);
    }
}
